import React from "react"
import {ContentWrapper} from "../elements"

export const Content =({children}) => {
    return <ContentWrapper>
       {children}
        </ContentWrapper>
}